import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppService {

  config = environment;

  constructor(
    private _http: HttpClient
  ) { }

  // url = "http://160.0.252.115:8600/geoserver/efb/wms?service=WMS&version=1.1.0&request=GetMap&layers=efb%3Aefb_parcel&bbox=398468.1808236276%2C801360.9487952989%2C399365.3613211583%2C802893.3580511481&width=449&height=768&srs=EPSG%3A32631&styles=&format=image%2Fpng"
  url = "http://172.17.0.40:8600/geoserver/efb/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=efb%3Aefb_parcel&outputFormat=application%2Fjson"

  getmapRequest() {
    return this._http.get( this.url )
  }

  getNupInfo(nup) {
    return this._http.get( this.config.BASE_URL_SMS +`/getInformationParcel/${nup}` )
  }

  getCommune() {
    return this._http.get( this.config.BASE_URL_SMS +`/all-commune` )
  }
}

